import * as React from 'react';
import { SvgIcon } from '@progress/kendo-react-common';
import { plusIcon } from '@progress/kendo-svg-icons';
import AddCarrierContactDialog from 'views/AssetCarriers/AddCarrierContactDialog';
import { IDName } from '../types/idname';

export type CarrierContactInputValue = {
  CarrierContactID: number;
  CarrierID?: number;
}

type Props = {
  CarrierContacts: IDName[];
  CarrierID: number;
  CarrierContactID: number;
  onChange: (response: CarrierContactInputValue) => void;
  prependGroup?: boolean;
}

const CarrierContactInput = (props: Props) => {
  const [showAddCarrierContactDialog, setShowAddCarrierContactDialog] = React.useState(false);

  const openCarrierContact = () => {
    if (props.CarrierContactID) {
      window.open(`/Assets/Carrier/Contact/${props.CarrierContactID}`);
    } else {
      window.open(`/Assets/Carrier/${props.CarrierID}/Contacts`);
    }
  };

  return <>
    {showAddCarrierContactDialog && <AddCarrierContactDialog
      CarrierId={props.CarrierID}
      CloseDialog={() => setShowAddCarrierContactDialog(false)}
    />}
    <select
      className="custom-select"
      value={props.CarrierContactID}
      onChange={(e) => props.onChange({ CarrierContactID: parseInt(e.target.value) })}
    >
      <option value="0">Select Contact</option>
      {props.CarrierContacts.map((contact, index) => (
        <option key={index} value={contact.ID}>{contact.Name}</option>
      ))}
    </select>
    {props.CarrierID > 0 && window.isTMS && <div className="input-group-append">
      <button className="btn btn-outline-secondary" type="button" onClick={() => setShowAddCarrierContactDialog(true)}>
        <SvgIcon icon={plusIcon} />
      </button>
    </div>}
    {props.CarrierID > 0 && <div className="input-group-append">
      <button className="btn btn-outline-secondary" type="button" onClick={openCarrierContact}>Open</button>
    </div>}
  </>;
};

export default CarrierContactInput;
